import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { ProductList, PageBreadcrumb } from '../..'

const ITEMS_PER_PAGE = [
  20,
  40,
  60,
  80,
  100
]
const DEFAULT_SORTMODE_DESC = 1

const CategoryLevel2View = ({ category, parent, children, products, attributes, attribute_groups, breadcrumbs, navigation, lang }) => {
  let initialSortBy = 'date_add'
  let initialSortMode = DEFAULT_SORTMODE_DESC

  const [itemsPerPage, setItemsPerPage] = useState(ITEMS_PER_PAGE[2])
  const [sortBy, setSortBy] = useState(initialSortBy)
  const [sortMode, setSortMode] = useState(initialSortMode)

  return (
    <div className="product-list-4 product-list-breadcrumbs">
      <PageBreadcrumb
        lang={lang}
        current={{ title_nl: category.name_nl, title_en: category.name_en, ...category }}
        items={breadcrumbs} />

      <ProductList
        title={category[`name_${lang.suffix}`]}
        products={products}
        attributes={attributes}
        attribute_groups={attribute_groups}
        lang={lang}
        navigation={navigation}
        keyPrefix={`category-${category.id_category}-item`}
        sortBy={sortBy} setSortBy={setSortBy}
        sortMode={sortMode} setSortMode={setSortMode}
        itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage}
        availableItemsPerPage={ITEMS_PER_PAGE} />
    </div>
  )
}

CategoryLevel2View.propTypes = {
  category: PropTypes.object.isRequired,
  parent: PropTypes.object,
  children: PropTypes.array,
  products: PropTypes.array,
  attributes: PropTypes.array,
  attribute_groups: PropTypes.array,
  breadcrumbs: PropTypes.array,
  navigation: PropTypes.object,
  lang: PropTypes.object
}

export default CategoryLevel2View
